export enum WorkflowStepFunctionTypes {
  Function = 'function'
}
